<template>
  <validation-observer v-slot="{ invalid }" tag="div" class="modal-edit-custom-machine">
    <h2>{{ options.node.name }}</h2>
    <oie-action-wrapper>
      <oie-base-action v-if="!isDeleting" theme="skeleton" @click="isDeleting = true">
        <template #iconPrepend>
          <oie-base-icon icon="trash-can" size="xs"></oie-base-icon>
        </template>
        {{ tStatic('genericDelete') }}
      </oie-base-action>
    </oie-action-wrapper>
    <template v-if="isDeleting">
      <p class="modal-edit-custom-machine__warning">
        {{ warningText }}
      </p>
      <oie-action-wrapper>
        <oie-base-action theme="destructive" @click="deleteNode">
          <template #iconPrepend>
            <oie-base-icon icon="trash-can" size="xs"></oie-base-icon>
          </template>
          {{ tStatic('genericDelete') }}
        </oie-base-action>
      </oie-action-wrapper>
    </template>
    <validation-provider v-slot="{errors}" rules="required" slim>
      <oie-base-input v-model="text" label-text="Name" :error-messages="errors"></oie-base-input>
    </validation-provider>
    <oie-action-wrapper>
      <oie-base-action theme="flat" size="large" @click="abort">
        {{ tStatic('cancel') }}
      </oie-base-action>
      <oie-base-action size="large" :disabled="invalid" @click="editNode">
        {{ tStatic('genericSave') }}
      </oie-base-action>
    </oie-action-wrapper>
  </validation-observer>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    options: { type: Object, required: true }
  },
  data() {
    return {
      isDeleting: false,
      text: ''
    }
  },
  computed: {
    warningText() {
      const isType = !!this.options.node.brands
      const isBrand = !!this.options.node.models
      if(isType) return this.t('typeWarningText')
      if(isBrand) return this.t('brandWarningText')
      return this.t('genericWarningText')
    }
  },
  mounted() {
    this.text = this.options.node.name
  },
  methods: {
    ...mapActions('myMachines', ['updateCustomMachine', 'deleteCustomMachine']),
    async editNode() {
      await this.updateCustomMachine({ id: this.options.node.id, name: this.text })
      this.publish('modal.hide.edit-custom-machine')
    },
    async deleteNode() {
      await this.deleteCustomMachine({ id: this.options.node.id })
      this.publish('modal.hide.edit-custom-machine')
    },
    abort() {
      this.publish('modal.hide.edit-custom-machine')
    }
  }
}
</script>

<style lang="scss">
.modal-edit-custom-machine >*:not(:last-child) {
  margin-bottom: measure(quarter);
}

.modal-edit-custom-machine__warning {
  color: var(--text-red)
}

</style>
